<template>
  <div class="game">

    <van-nav-bar class="nav-bar">
      <template #left>
        <img @click="$router.push('/')" src="img/home.png" style="width: 30px; ">
      </template>
      <template #right>
        <img @click="service" style="width: 30px; "
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABXJJREFUaEPVmb2yDUEUhZdcFV7AzxMgUSVCgBClxHgCPIBCkeMF/IQkSAkQCxCQ4gnwAIr6bs06tc8+09M9c2YCXXXr3nvOme691l577e4+u/Sfj10LxH9E0p5u3pOSvnc/vPR+7vXmALBX0jlJBHteEv8PjXeSXkp6FYBNxrUNAAK9Jul6Q9ClAJ9Ieijp01QEUwFckXR/IPDPkn6loE4MBPlA0p2eZ6q4xgKA9cedVOLkvyXBpuVRWpj6QGoQcDh9iFq5MDYbYwAQ/FtJBOFB4LDHT2a8xh5AbkuKmWEOQEBE02gF0Bc8RQiTfYEflHQgAS3pnBpCjnFc7TJaBdEK4GNi/kbHuhcA4OVOHjBbciJAwC6Fi2Q8yCqv234h5VSLnFoAIA/cxiOyQ6Cwl+2zr4hjf2AuAqZwLZcMArCAGJRmDQBsonsPFkS3DEDxt9l+2vk7Hl8aBAlYpGeJUfxklEAzCDKFxIqjBuCbJPTMoIsCiIETEQSDwFlkbBHzDAQgG9gms/zONXFoqOENAcjseyLXAw4Em82O0UMj2SNjOFHUPXPanSDIZG1MMQQA6ZhxT2Lm0TjBx0IcynTtPWSECQACopBSlG4xCyUAyAb5eDABLNySBPO8P1YyGQRBModJMAhkdLTLrLOQXW81VwkAwcK2tY8ukQ6DySfvXbqsMjckIBWcxoN56dAuasdgUM0SQpfsMBlMhpT4P7pQTRal93+mPhHZJSsQ5XowaczlrQpyLmaACfB1a58P0tpfzCQdGwOO5qwSLFnNUoKsaLcOGnKJaWdECZFSEOMM6JyBxbEAr83Bvi3Sc7lJRqdx/XldYrELYbtIbNVMI4A8GROhPbf3QT9u0BMkQBDzuo54DeZZI84fbTQSh/OhhhXgCMAPUVT2dhDbeWonrSEMSJOC5HdsiDzjNWIWbCLZ8aIEd2ReA+B0svMEfcsgSNLMsyzC/wZP/+C1aMExC/uCZMkMqvDWhbVHA3D1IyUmy8PB8tuHlT6QBI6L9M3hNWhk0ZEcfAQ7CQBMwlL0frKBW3mfFINGIrDH5719rmVuI7Au43ljOAuA2OR+dHsZB7tNg/ubnJHgkU+ccxIAUm8JudGwVrG91+guvG8TsUPR8Hzq8yOjAeQidoeeoydkHLZxmhQSdBeO9joagC2OQsIhSPNcm7kMwGtBDgP7ZkSyLN+VK0Yb9QRIhk4XOzMT8Rpenn18omI2HosA2HfF2w+yYxljKL2dOHderwDjdEoaDVa3NACvg0EAyjtSx7N2wMnbaVDzEAz4sgr0nA3QpW2zdhSdkhVnwM/aJFiT2qM5btReayA+bHhyCm3o8L4tgFxn3oJvnEVaAeQT2uA5tRL9bkn7JX1Nn4sbuGjRdh4ktdE4WwGwVmxgPruOPVaelnRX0k1JbxIAs5xrzGfzXuseAyDuWbK9ORZ0TJBfOtcwy8ck8XOxC/5eCj7uPqlDH27izYg3emuPjgWAhVEPPm72nY8vSXpekNEHSccl/Qnv+5xAgATsrUO8jy1ecI0F4HXjDULf9d/ZLtAz3e9nkh5Jet0DjAOKbz3ivide4eQt+GqaqQCYgB0pQAiAxjJlECSOg/RiPcWbv8FbkG0AEDBp5pwLc1NsFb1H1n1Z7DNw9Zp9WwBTWC89g0x8X0RWYj0U11kKgL8AZGEcZe0uJ0VDoGzcfJXD6Y0MNJ0tlgCQN4G231gn8WtZNyd/XRXPwNUMLwHADgXrdFf2UmwG+Tse8B0cHdbn5bGNce1Wooq28QP5ZJW/4WEaZOJvNLe5nl8EQOwRBOdvWPwV6lxX8jt8LiEhCpjA4/fAVTtszO7Gx5YA4EV8qUV/mJX1iGJJAFNJHfXcP/mqiEDZsEJxAAAAAElFTkSuQmCC">
      </template>
    </van-nav-bar>

    <div class="header-holder"></div>
    <div style="padding: 16px 8px 0px;">
      <img alt="" src="img/grab.jpg" style="width: 100%;">
    </div>
    <div class="card">
      <div class="title"><span style="font-size: 1.5rem;">{{ $store.getters.getBaseInfo.currency }} {{ data.money*1  }}</span>
        <p>{{ $t("账户资金") }}</p></div>
      <div class="base-container">
        <div style="text-align: left; color: rgb(255, 255, 255); font-size: 1.5rem; font-weight: bold; padding: 6px;">
          <div style="font-size: 0.9rem; font-weight: normal;">{{ $t("佣金") }} {{ data.commission_rate }}% | {{ data.order_num }} {{ $t("订单") }}</div>
        </div>
        <div style="width: 100%; height: 6px;"></div>
        <div class="base">
          <div class="item"><span>{{ data.order_num - data.day_order_num }}</span>
            <p>{{ $t("剩余次数") }}</p></div>
          <div class="item"><span>{{ data.order_num }}</span>
            <p>{{ $t("已完成") }}</p></div>
          <div class="item"><span>{{ data.order_incomplete_num }}</span>
            <p>{{ $t("未完成") }}</p></div>
        </div>
        <div style="width: 100%; height: 6px;"></div>
      </div>
      <div>
        <div class="profit-list">
          <div class="profit-item"><span>{{ $store.getters.getBaseInfo.currency }} {{ data.difference }}</span>
            <p>{{ $t("差额") }}</p></div>
          <div class="profit-item"><span>{{ $store.getters.getBaseInfo.currency }} {{ data.tod_user_yongjin }}</span>
            <p>{{ $t("今天佣金") }}</p></div>
        </div>
      </div>
    </div>

    <van-button class="login-btn" type="primary" @click="getDd()" size="normal" style="margin: 10px ;border-radius:5px;color: white; background: rgb(109, 0, 190); border-color: rgb(109, 0, 190);padding: 20px">
        {{ $t("开始接受订单") }}
    </van-button>

    <div style="font-size: 0.8rem; color: rgb(109, 0, 190);text-align: center" @click="$router.push({path:'/grablist'});">{{ $t("订单历史记录") }}</div>
    <div style="height: 100px"></div>

    <van-loading size="24px" vertical v-show="loading">{{ $t('加载中') }}...</van-loading>

    <van-dialog v-model="showTj" :confirmButtonText="$t('确定')" :cancelButtonText="$t('取消')"
                :show-confirm-button="true" :title="$t('订单详情')" show-cancel-button @confirm="confirmPwd()">
      <template #title>
        <div style="text-align: center">{{ $t('订单详情') }}</div>
      </template>
      <div class="list" >
        <div style="text-align: center;" v-if="onceinfo.need > 0">
          <div style="color:#fde259;">{{ $t("幸运订单") }}</div>
          <div style="margin-top: 10px;background: #fde259;color: red; border-radius: 5px;padding: 10px;font-size: 28px">{{ $t("完成订单还需额外支付100").replace("100",  $store.getters.getBaseInfo.currency + onceinfo.need) }}</div>
        </div>
        <div class="cet" style="margin-top: 10px">
          <img :src="onceinfo.goods_pic" class="img" alt="">
        </div>
        <div class="monney">

          <div style="text-align: center;margin-bottom: 10px">
            {{ onceinfo.goods_name }}
          </div>
          <div class="tent" v-if="false">
            <span class="span">{{$t('评估')}}</span>
            <div style="width: 2rem;"></div>
            <review class="span" @qhf="qhfun"  v-model="num"  ></review>

          </div>

          <div class="tent">
            <span class="span">{{ $t('订单号') }}</span>
            <span class="value">{{ onceinfo.oid }}</span>
          </div>
          <div class="tent">
            <span class="span">{{ $t('抢单时间') }}</span>
            <span class="value">{{ onceinfo.addtime }}</span>
          </div>

          <div class="tent" >
            <span class="span">{{ $t('差额') }}</span>
            <span class="value">{{ $store.getters.getBaseInfo.currency + onceinfo.difference }}</span>
          </div>

          <div class="tent">
            <span class="span">{{ $t('总金额') }}</span>
            <span class="value">{{ $store.getters.getBaseInfo.currency + onceinfo.num }}</span>
          </div>
          <div class="tent">
            <span class="span">{{ $t('佣金') }}</span>
            <span class="value">{{ $store.getters.getBaseInfo.currency + onceinfo.commission }}</span>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {

  data() {
    return {
      data: {},
      showTj:false,
      num: 0,
      onceinfo: {},
      loading:false,
    }
  },
  methods: {
    qhfun(num){
      this.num = num
    },
    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'grab_info'
      }).then(res => {
        if (res.code === 200) {
          this.data = res.data;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    getDd(){
      if(this.loading){
        return false;
      }
      this.loading = true;
      setTimeout(async () => {
        this.num = 0;
        this.$http({
          method: 'get',
          data:{},
          url: 'submit_order'
        }).then(res=>{

          this.$toast(this.$t(res.msg));
          if(res.code === 200){
            this.oid = res.data.oid;
            this.tjOrder()
          }
        })
      }, 1000);
    },
    tjOrder(){
        this.num = 0;
        this.$http({
          method: 'post',
          data:{
            oid: this.oid
          },
          url: 'order_info'
        }).then(res=>{
          if(res.code == 200){
            this.loading = false
            this.onceinfo = res.data
            this.showTj = true
          }else {
            this.$toast(this.$t(res.msg));
          }
        })
      },
    confirmPwd() {
      this.$http({
        method: 'post',
        data:{
          oid: this.oid,
          status: 1,
          num: 5
        },
        url: 'do_order'
      }).then(res=>{
        this.$toast(this.$t(res.msg).replace("100",this.$store.getters.getBaseInfo.currency + res.data));
        if(res.code == 200){
          this.showTj = false
          this.getUserInfo();
        }
      })

    }
  },
  created() {
    if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
    } else {
        this.getUserInfo();

    }
  },
}
</script>

<style  scoped>

::v-deep .van-dialog__cancel{
    height: 100px;
  line-height: 100px;
  font-size: 32px;
}
::v-deep .van-dialog__confirm{

  height: 100px;
  line-height: 100px;
  font-size: 32px;
}
.van-button {
  font-size: 28px;
  margin-top: 50px;
}
.van-dialog{
  width: 80%;
  font-size: 28px;
}
.game {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(180deg,#fcedff 0,#fff)
}

.game .profit-list {
  display: grid;
  grid-template-columns: repeat(2,1fr);
  padding: .26667rem .66667rem;
  box-sizing: border-box
}

.game .profit-list .profit-item {
  padding: .13333rem 0
}

.game .profit-list .profit-item p {
  color: #888;
  font-size: .8rem
}

.game .profit-list .profit-item span {
  font-size: .8rem
}

.game .profit-list .profit-item:nth-child(1n) {
  text-align: left
}

.game .profit-list .profit-item:nth-child(2n) {
  text-align: right
}

.game .card {
  background: #fff;
  border-radius: .66667rem;
  width: 95%;
  margin: .4rem auto .26667rem auto;
  box-shadow: 0 0 .33333rem rgba(0,0,0,.2);
  padding: 0
}

.game .card .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .66667rem .66667rem;
  border-bottom: 1px solid #e5e5e5
}

.game .card .title p {
  font-size: 1rem;
  color: #707070
}

.game .card .title span {
  font-weight: 600;
  color: #6d00be;
  font-size: .9rem
}

.game .card .base-container {
  padding: .4rem .66667rem;
  background: linear-gradient(135deg,#8074e1,#9c61be 50%,#c14d90);
  border-radius: .4rem
}

.game .card .base-container .base {
  display: flex;
  justify-content: space-around;
  align-items: center
}

.game .card .base-container .base p {
  font-size: 1rem;
  color: #fff
}
.game .card .base-container .base .item {
  text-align: center;
}

.game .card .base-container .base span {
  font-weight: 600;
  color: #fff;
  font-size: .9rem
}

.game .card .shouyi {
  display: flex;
  justify-content: space-between;
  padding: .66667rem;
  box-sizing: border-box
}

.game .card .shouyi .item {
  text-align: left
}

.game .card .shouyi .item:last-child {
  text-align: right
}

.game .card .shouyi .item p {
  font-size: .66667rem;
  color: #aaa;
  padding: .33333rem 0;
  text-align: center
}

.game .card .shouyi .item span {
  font-size: .86667rem;
  color: #303133;
  padding: .33333rem 0;
  display: block
}

.game .van-popup--center {
  padding: 20px;
  border-radius: 10px;
  top: 50%
}

.game .add {
  width: 92%!important;
  padding: 0;
  text-align: left
}

.game .add>p {
  background: linear-gradient(135deg,#a700ff,#00189a);
  color: #fff;
  display: inline-block;
  width: 90%;
  padding: .33333rem;
  font-size: .9rem;
  border-radius: 0 0 .66667rem 0
}

.game .add>span {
  display: block;
  padding: .33333rem 2%;
  font-size: .9rem;
  color: #9e9e9e
}

.game .add .van-button__text {
  color: #fff
}

.game .add .box {
  display: flex;
  justify-content: space-between;
  align-items: center
}

.game .add .box .image {
  width: 6.66667rem;
  height: 6.66667rem;
  overflow: hidden
}

.game .add .box .image img {
  width: 100%
}

.game .add .box .beyt {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding-left: .66667rem;
  width: 100%;
  padding-right: .66667rem
}

.game .add .box .beyt>span {
  width: 100%;
  font-size: .76667rem
}

.game .add .box .beyt>span:last-child {
  padding-top: .66667rem;
  font-size: .86667rem;
  display: flex;
  justify-content: space-between;
  align-items: center
}

.game .add .word {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: .66667rem;
  padding-left: .66667rem;
  padding-right: .66667rem
}

.game .add .word span span {
  color: grey;
  padding-left: .33333rem
}

.game .account-panel {
  padding: 1rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  text-align: left
}

.game .account-panel .account-money {
  font-size: 1.6rem;
  font-weight: 700
}

.game .account-panel img {
  width: 3.33333rem
}

.game .van-button--block {
  width: 70%;
  margin: 20px auto;
  padding: 20px 0
}

.game .msg {
  background: #fff;
  width: 95%;
  margin: 0 auto;
  border-radius: .66667rem;
  padding: 1rem .66667rem
}

.game .msg .title {
  text-align: left;
  padding: .33333rem 0 .66667rem;
  border-bottom: 1px solid #efefef
}

.game .msg p {
  text-align: left;
  padding: .66667rem 0;
  color: #999;
  font-size: .86667rem
}

.game .image-shower {
  margin: 1rem auto;
  width: 90%;
  display: flex;
  justify-content: space-between;
  -moz-column-gap: .8rem;
  column-gap: .8rem
}

.game .image-shower .image-shower-item {
  border: 1px solid #6d00be;
  flex: 1
}

.game .van-swipe,.game .van-notice-bar__content {
  width: 100%
}

.game .van-swipe-item {
  display: flex;
  justify-content: space-between;
  align-items: center
}

.game .van-nav-bar:after {
  border-bottom-width: 0
}

.game .van-nav-bar .van-nav-bar__title {
  color: #6d00be
}

.game .van-cell-group {
  text-align: left
}

.game .van-cell-group h1 {
  font-weight: 400;
  font-size: 28px;
  padding: 10px 0;
  color: #6b6b6b
}

.game .van-cell-group .van-button--block {
  width: 70%;
  margin: 20px auto;
  border-radius: 10px
}

.game .van-cell-group .van-cell:before {
  display: none
}

.game .van-cell-group .van-field__control {
  font-size: 16px
}
p{
  margin: 0;
}

.list {
  padding: 30px;
  box-shadow: 0 0 20px 0 #e9e9e9;
  color: #999;
  text-align: left;
  margin-top: 40px;
  border-radius: 10px;

.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 35px;

.time {
  font-size: 16px;
}

.tab {
  font-size: 20px;
  color: #02b2d6
}

}

.cet {
  display: flex;
  background-color: #fafafa;
  padding: 10px 0;

.img {
  width: 100%;
  height: 180PX;
}

.text {
  font-size: 20px;
}

}

.monney {
  margin-top: 30px;

.tent {
  display: flex;
  justify-content: space-between;
  font-size: 28px;

.span {
  color: #333;
}

}
}
}
</style>